<script lang="ts">
    import type { PageProps } from '@kestrel/server';
    import ApmBoundary from '@shared/components/apm-boundary/ApmBoundary.svelte';
    import TrackingEsi from '@shared/components/tracking-esi/TrackingEsi.svelte';
    import TileListFallbackRoute from '@tilelist/application/wiring/TileListFallbackRoute.svelte';

    let { data }: PageProps<typeof import('./page.server.ts')> = $props();
</script>

<ApmBoundary scope="tilelist-fallback">
    {#if data.state === 'success'}
        <TrackingEsi requests={data.payload.trackingRequests} />
        <TileListFallbackRoute result={{ state: 'success', payload: data.payload.initialSession }} />
    {:else}
        <TileListFallbackRoute result={data} />
    {/if}

    {#snippet failed()}
        <TileListFallbackRoute result={{ state: 'error' }} />
    {/snippet}
</ApmBoundary>
